import { Alert, AlertTitle } from '@mui/material'
import { useTranslator } from '@/hooks'
import { IHttpError } from '@/@data'

interface ErrorAlertProps {
  error?: IHttpError | null
  onClose?: () => void
}

export const ErrorAlert = ({ error, onClose }: ErrorAlertProps) => {
  const { __ } = useTranslator()

  if (!error) return null

  const renderMessage = () => {
    if (!error.message) return null

    if (Array.isArray(error.message)) {
      return error.message.map((item, index) => {
        if (typeof item === 'object' && item.errors) {
          return (
            <div key={index} className='flex flex-col'>
              {item.errors.map((err: string, errIndex: number) => (
                <span key={errIndex} className='ml-2'>
                  • {__(err)}
                </span>
              ))}
            </div>
          )
        }

        return <div key={index}>{__(item)}</div>
      })
    }

    return <div>{error.message}</div>
  }

  return (
    <Alert
      severity='error'
      onClose={onClose}
      sx={{
        mb: 2,
        '& .MuiAlert-message': {
          width: '100%'
        }
      }}
    >
      <AlertTitle>{__('Error')}</AlertTitle>
      <div className='flex flex-col gap-1'>
        {renderMessage()}
        {error.errors &&
          Object.entries(error.errors).map(([key, messages]) => (
            <div key={key} className='flex flex-col'>
              <span className='font-medium capitalize'>{key.replace(/_/g, ' ')}:</span>
              {messages.map((message, index) => (
                <span key={index} className='ml-2'>
                  • {message}
                </span>
              ))}
            </div>
          ))}
      </div>
    </Alert>
  )
}
